// @flow
import React from "react";

import BlogCardView from "./BlogCardView";

export default class BlogCardController extends React.Component {
 

  render() {
    return (
      <BlogCardView {...this.props} />
    );
  }
}
